import React from 'react';
import { EventType } from '@graphql/generated';
import { SocialAccount } from '@shared/createEvent/SocialAccount';

import { CREATE_BABY_REGISTRY_APP_NAME } from '@apps/createBabyRegistry/constants';

export const SocialAccountWrapper = () => {
  return <SocialAccount appName={CREATE_BABY_REGISTRY_APP_NAME} eventType={EventType.babyRegistry} />;
};
